<template>
    <div v-if="trainingClass">
        <v-toolbar color="cyan" dark flat>
            <v-toolbar-title>{{trainingClass.title}} (CL-{{trainingClass.id}}) - {{trainingClass.company}}
            </v-toolbar-title>
            <v-spacer/>
            <v-img :src="trainingClass.iconUrl" max-height="50" max-width="50"/>
            <v-progress-linear
                    :active="updating || $apollo.loading"
                    :indeterminate="updating || $apollo.loading"
                    absolute
                    background-color="blue"
                    color="red accent-4"
                    height="5"
                    top
            ></v-progress-linear>

            <template v-slot:extension>
                <v-tabs
                        align-with-title
                        v-model="tab"
                >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#overview">
                        Overview
                    </v-tab>

                    <v-tab href="#attendees">
                        <v-badge
                                :color="trainingClass.allAttendees.length > 0 ? 'green' : 'red'"
                                :content="String(trainingClass.allAttendees.length)"
                        >
                            Attendees
                        </v-badge>
                    </v-tab>

                    <v-tab href="#sessions">
                        <v-badge
                                :color="trainingClass.sessions.length > 0 ? 'green' : 'red'"
                                :content="String(trainingClass.sessions.length)"
                        >
                            Sessions
                        </v-badge>
                    </v-tab>
                    <v-tab href="#courseware">
                        <v-badge
                                :color="trainingClass.manuals.length > 0 ? 'green' : 'red'"
                                :content="String(trainingClass.manuals.length)"
                        >
                            Courseware
                        </v-badge>
                    </v-tab>
                    <v-tab href="#pre-course">
                        <v-badge
                                :color="trainingClass.precourseQuestionnaires.length > 0 ? 'green' : 'red'"
                                :content="String(trainingClass.precourseQuestionnaires.length)"
                        >
                            Pre-Course
                        </v-badge>
                    </v-tab>
                    <v-tab href="#feedback">
                        <v-badge
                                :color="trainingClass.feedbackDelegates.length > 0 ? 'green' : 'red'"
                                :content="String(trainingClass.feedbackDelegates.length)"
                        >
                            Feedback
                        </v-badge>
                    </v-tab>
                    <v-tab href="#history">
                        History
                    </v-tab>
                </v-tabs>
                <v-btn @click="sendJoining"
                       color="orange"
                       light
                       class="ma-2"
                       small>Send Joining Instructions</v-btn>
                <PythiaLink v-model="trainingClass.id" type="class" class="ma-2" />
            </template>
        </v-toolbar>

        <v-container class="grey lighten-3" fluid>
            <v-row>
                <v-col cols="12">
                    <v-tabs-items :value="tab">
                        <v-tab-item value="overview">
                            <TrainingClassForm
                                    :model="trainingClass"
                                    @saved="savedEvent"
                            />
                        </v-tab-item>

                        <v-tab-item value="attendees">
                            <TrainingClassAttendees
                                    :model="trainingClass"
                            />
                        </v-tab-item>

                        <v-tab-item value="sessions">
                            <TrainingSessionsManage
                                    :model="trainingClass"
                                    @saved="savedEvent"
                            />

                        </v-tab-item>

                        <v-tab-item value="courseware">
                            <TrainingClassCourseware
                                    :model="trainingClass"
                                    @saved="savedEvent"
                            />
                        </v-tab-item>
                        <v-tab-item value="pre-course">
                            <TrainingClassPreCourse
                                    :model="trainingClass"
                            />
                        </v-tab-item>
                        <v-tab-item value="feedback">
                            <TrainingClassFeedback
                                    :model="trainingClass"
                            />
                        </v-tab-item>
                    </v-tabs-items>
                </v-col>
            </v-row>
          <Confirm ref="confirm"/>
        </v-container>

    </div>

</template>

<script>

    import Dashboard from "../layouts/Dashboard"
    import TRAINING_CLASS from "../graphql/TrainingClassGet.gql"
    import TrainingClassForm from "../components/TrainingClass/TrainingClassForm";
    import TrainingSessionsManage from "../components/TrainingClass/TrainingSession/TrainingSessionsManage.vue";
    import TrainingClassAttendees from "../components/TrainingClass/TrainingClassAttendees.vue";
    import TrainingClassCourseware from "../components/TrainingClass/TrainingClassCourseware.vue";
    import TrainingClassPreCourse from "../components/TrainingClass/TrainingClassPreCourse.vue";
    import TrainingClassFeedback from "../components/TrainingClass/TrainingClassFeedback.vue";
    import PythiaLink from "../components/PythiaLink";
    import ApiMixin from "../mixins/ApiMixin";
    import Confirm from "../components/Confirm";

    export default {
        name: "training-class",
        components: {
            TrainingClassForm,
            TrainingSessionsManage,
            TrainingClassAttendees,
            TrainingClassCourseware,
            TrainingClassPreCourse,
            TrainingClassFeedback,
            PythiaLink,
            Confirm
        },
        mixins: [ApiMixin],
        metaInfo() {
            return {
                title: this.title
            }
        },
        data() {
            return {
                title: 'CL-' + this.$route.params.id,
                tab: this.$route.query.tab,
                classDetailsUpdating: false,
                id: parseInt(this.$route.params.id),
                errored: false,
                saved: false,
                updating: false,
            }
        },
        apollo: {
            trainingClass: {
                query: TRAINING_CLASS,
                variables() {
                    return {id: parseInt(this.id)}
                },
                update: data => data.trainingClass,
                error (error) {
                    this.$store.dispatch('notification/handleGraphQlError', error)
                }
            },
        },
        watch: {
            tab(tab) {
                this.$router.replace({query: {...this.$route.query, tab}})
            },
            updating(value) {
                this.$store.dispatch('notification/loading', value)
            }
        },
        created() {
            this.$emit('update:layout', Dashboard);
        },
        methods: {

            savedEvent() {
                this.$apollo.queries.trainingClass.refetch()
                this.saved = true
            },

            sendJoining() {

              this.$refs.confirm.open('Send Joining Instructions', 'Are you sure?', { color: 'orange' }).then((confirm) => {
                if(!confirm) {
                  return;
                }

                this.updating = true
                this.sendJoiningInstructions(this.trainingClass.id).then(() => {
                  this.updating = false
                  this.$store.dispatch('notification/addSuccess', 'Completed successfully')
                }).catch((error) => {
                  this.updating = false
                  this.$store.dispatch('notification/addError', error.message)
                })
              })
            },


        }
    };
</script>

<style scoped>

</style>
